import { styles } from 'assets/scss/style-templates';
import { CSSProperties } from 'react';

const useAddAttachmentStyles = () => ({
  textAndWarningContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 1,
  },
  fileSilzeWarningText: { color: styles.color.red },
  fileInput: {
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
  } as CSSProperties,
});

export default useAddAttachmentStyles;
